<template>
  <nav class="navbar navbar-expand-lg navbar-light sticky-top p-2 p-md-4">
    <div class="container">
      <router-link to="/" class="navbar-brand">
        <img src="/logo.svg" width="40" height="40"
             class="d-inline-block align-top" alt=""/>
      </router-link>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar"
              aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbar">
        <ul class="navbar-nav mx-auto mb-2 mb-lg-0">
          <li class="nav-item me-2">
            <router-link to="/" class="nav-link" exact>
              Beranda
            </router-link>
          </li>
          <li class="nav-item me-2">
            <router-link to="/tentang" class="nav-link">Tentang</router-link>
          </li>
          <li class="nav-item me-2">
            <router-link to="/laporan" class="nav-link">Laporan Sekolah</router-link>
          </li>
          <li class="nav-item me-2">
            <router-link to="/peta" class="nav-link">Peta Penyebaran Sekolah</router-link>
          </li>
          <li class="nav-item me-2">
            <router-link to="/faq" class="nav-link">FAQ</router-link>
          </li>
          <li class="nav-item me-2">
            <router-link to="/kontak" class="nav-link">Kontak</router-link>
          </li>
        </ul>
        <a href="/login" class="btn btn-primary px-4 py-2">Masuk</a>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navbar',
  props: {
    msg: String
  }
}</script>
